module.exports = __webpack_public_path__ + "static/img/2areaA_41.c7268ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/2areaA_41.png
// module id = 856
// module chunks = 1